import { Code, TrimmedCode } from "types/entities/Code";

export const checkCodeHasChanges = (code: Code, newCode: TrimmedCode) => {
  return code.code !== newCode.code || code.type !== newCode.type;
}
